import React, { createContext, useContext, useState, useCallback } from 'react';
import { dmsApi } from '../services/dmsApi';

const DmsContext = createContext(null);

export function DmsProvider({ children }) {
  const [documents, setDocuments] = useState([]);
  const [folders, setFolders] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedVault, setSelectedVault] = useState('procedures');
  const [selectedFolder, setSelectedFolder] = useState(null);

  const loadDocuments = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const data = await dmsApi.listDocuments({ vault: selectedVault, folder: selectedFolder, ...params });
      setDocuments(data.documents || []);
    } catch (err) {
      setError(err.error || 'Failed to load documents');
    } finally {
      setLoading(false);
    }
  }, [selectedVault, selectedFolder]);

  const loadFolders = useCallback(async () => {
    try {
      const data = await dmsApi.listFolders({ vault: selectedVault });
      setFolders(data || []);
    } catch (err) {
      console.error('Failed to load folders:', err);
    }
  }, [selectedVault]);

  const loadStats = useCallback(async () => {
    try {
      const data = await dmsApi.getStats();
      setStats(data);
    } catch (err) {
      console.error('Failed to load stats:', err);
    }
  }, []);

  return (
    <DmsContext.Provider value={{
      documents, folders, stats, loading, error,
      selectedVault, setSelectedVault,
      selectedFolder, setSelectedFolder,
      loadDocuments, loadFolders, loadStats,
      setDocuments,
    }}>
      {children}
    </DmsContext.Provider>
  );
}

export const useDms = () => {
  const ctx = useContext(DmsContext);
  if (!ctx) throw new Error('useDms must be inside DmsProvider');
  return ctx;
};
